import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { useEffect, useRef } from "react";
import useHelpers from "@hooks/useHelpers";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Else } from "@componentsShared/Conditional/Else";
import { Then } from "@componentsShared/Conditional/Then";
import { Icon } from "@syarahtech/ui";
import AnyQuestion from "@/pages/faqs/FaqComponents/AnyQuestion";
import useIsMobile from "@hooks/useIsMobile";
import { If } from "@componentsShared/Conditional/If";
import useIsWebView from "@hooks/useIsWebview";
import useWebview from "@hooks/useWebview";
import { URL_SELL_TRADE_LANDING_v2 } from "@/pages/sell-trade-v2/sell-trade/constants";
import FLowLoadingSpinner from "@/pages/sell-my-car/components/FLowLoadingSpinner";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
var CarBookingSuccessScreen = function CarBookingSuccessScreen() {
  var _state$draftOrder4, _state$draftOrder4$cu, _state$draftOrder5, _state$draftOrder7, _state$draftOrder8, _state$draftOrder8$cu, _state$draftOrder8$cu2, _state$draftOrder9, _state$draftOrder9$cu, _state$draftOrder9$cu2, _state$draftOrder0, _state$draftOrder0$cu, _state$draftOrder0$cu2, _state$draftOrder1, _state$draftOrder1$cu, _state$draftOrder1$cu2;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    actions = _useSellCarData.actions;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    navigateToHard = _useHelpers.navigateToHard;
  var isMobile = useIsMobile();
  var isWebView = useIsWebView();
  var webview = useWebview();
  var hasTrackedEvent = useRef(false);
  useEffect(function () {
    actions.fetchStepData();
  }, []);
  useEffect(function () {
    var _state$draftOrder, _state$draftOrder$cur, _state$draftOrder2;
    var stepData = state === null || state === void 0 ? void 0 : (_state$draftOrder = state.draftOrder) === null || _state$draftOrder === void 0 ? void 0 : (_state$draftOrder$cur = _state$draftOrder.currentStep) === null || _state$draftOrder$cur === void 0 ? void 0 : _state$draftOrder$cur.data;
    if (stepData && state !== null && state !== void 0 && (_state$draftOrder2 = state.draftOrder) !== null && _state$draftOrder2 !== void 0 && _state$draftOrder2.requestId && !hasTrackedEvent.current) {
      var _state$draftOrder3;
      hasTrackedEvent.current = true;
      trackEvents("sell_car_appointment_book", {
        order_id: state === null || state === void 0 ? void 0 : (_state$draftOrder3 = state.draftOrder) === null || _state$draftOrder3 === void 0 ? void 0 : _state$draftOrder3.requestId,
        car_city: (stepData === null || stepData === void 0 ? void 0 : stepData.city_name) || "",
        inspection_city: (stepData === null || stepData === void 0 ? void 0 : stepData.city_name) || "",
        inspection_location: (stepData === null || stepData === void 0 ? void 0 : stepData.location) || "",
        payment_status: (stepData === null || stepData === void 0 ? void 0 : stepData.inspection_location_type_id) == 'company_location' ? "null" : "success",
        platform: getPlatformInfo()
      });
    }
  }, [state === null || state === void 0 ? void 0 : (_state$draftOrder4 = state.draftOrder) === null || _state$draftOrder4 === void 0 ? void 0 : (_state$draftOrder4$cu = _state$draftOrder4.currentStep) === null || _state$draftOrder4$cu === void 0 ? void 0 : _state$draftOrder4$cu.data, state === null || state === void 0 ? void 0 : (_state$draftOrder5 = state.draftOrder) === null || _state$draftOrder5 === void 0 ? void 0 : _state$draftOrder5.requestId]);
  var handleGoHome = function handleGoHome() {
    navigateTo("/");
  };
  var handleCloseCLick = function handleCloseCLick() {
    navigateToHard(URL_SELL_TRADE_LANDING_v2);
  };
  useEffect(function () {
    if (isWebView) {
      var _state$draftOrder6;
      webview.openScreen("payment_success", {
        request_id: state === null || state === void 0 ? void 0 : (_state$draftOrder6 = state.draftOrder) === null || _state$draftOrder6 === void 0 ? void 0 : _state$draftOrder6.requestId
      }).then();
    }
  }, [isWebView]);
  if (!(state !== null && state !== void 0 && (_state$draftOrder7 = state.draftOrder) !== null && _state$draftOrder7 !== void 0 && _state$draftOrder7.requestId)) {
    navigateTo("/?ref=request_id_not_found");
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: isWebView
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(FLowLoadingSpinner, null)), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: state === null || state === void 0 ? void 0 : state.isLoading
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(FLowLoadingSpinner, null)), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Layout, {
    hasMobFooter: false,
    hideDownloadBanner: true
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-booking-success-close-btn",
    className: "fixed top-[20px] left-[20px] md:hidden z-[10000] en:left-[unset] en:right-[20px]",
    onClick: handleCloseCLick
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-outline-rounded",
    width: 6,
    height: 6,
    className: "text-primary-new"
  })), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-booking-success-screen",
    className: "px-3 py-4 md:max-w-[560px] md:mx-auto md:p-6 md:border-2 md:border-solid md:border-gray-echo md:rounded-lg md:mt-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 items-center max-w-[326px] mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 items-center"
  }, /*#__PURE__*/React.createElement("img", {
    id: "sell-car-booking-success-icon",
    src: CDN_LINK + "/assets/images/success-check.svg",
    alt: "success-check",
    className: "w-20 h-20"
  }), /*#__PURE__*/React.createElement("h3", {
    id: "sell-car-booking-success-title",
    className: "text-primary-new font-bold text-2xl leading-8 text-center"
  }, tShort("sell_trade_v2/success_title", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("p", {
    id: "sell-car-booking-success-description",
    className: "text-black-primary text-base leading-7 text-center"
  }, tShort("sell_trade_v2/success_description", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-booking-success-details",
    className: "border border-solid border-gray-echo w-full rounded"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border-b border-solid border-gray-echo w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full p-4"
  }, /*#__PURE__*/React.createElement("p", {
    id: "sell-car-booking-success-car-title",
    className: "text-sm text-black-primary font-bold"
  }, state === null || state === void 0 ? void 0 : (_state$draftOrder8 = state.draftOrder) === null || _state$draftOrder8 === void 0 ? void 0 : (_state$draftOrder8$cu = _state$draftOrder8.currentStep) === null || _state$draftOrder8$cu === void 0 ? void 0 : (_state$draftOrder8$cu2 = _state$draftOrder8$cu.data) === null || _state$draftOrder8$cu2 === void 0 ? void 0 : _state$draftOrder8$cu2.title))), /*#__PURE__*/React.createElement("div", {
    className: "ps-4 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-booking-success-date-row",
    className: "w-full p-4 border-b border-solid border-gray-echo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between "
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--today-outline-rounded",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-xs font-bold text-black-primary leading-6"
  }, tShort("sell_trade_v2/success_inspection_date", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("p", {
    id: "sell-car-booking-success-date-value",
    className: "text-sm font-semibold text-black-primary"
  }, state === null || state === void 0 ? void 0 : (_state$draftOrder9 = state.draftOrder) === null || _state$draftOrder9 === void 0 ? void 0 : (_state$draftOrder9$cu = _state$draftOrder9.currentStep) === null || _state$draftOrder9$cu === void 0 ? void 0 : (_state$draftOrder9$cu2 = _state$draftOrder9$cu.data) === null || _state$draftOrder9$cu2 === void 0 ? void 0 : _state$draftOrder9$cu2.appointment_date))), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-booking-success-time-row",
    className: "w-full p-4 border-b border-solid border-gray-echo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between "
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--schedule-outline-rounded",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-xs font-bold text-black-primary leading-6"
  }, tShort("sell_trade_v2/success_inspection_time", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("p", {
    id: "sell-car-booking-success-time-value",
    className: "text-sm font-semibold text-black-primary"
  }, state === null || state === void 0 ? void 0 : (_state$draftOrder0 = state.draftOrder) === null || _state$draftOrder0 === void 0 ? void 0 : (_state$draftOrder0$cu = _state$draftOrder0.currentStep) === null || _state$draftOrder0$cu === void 0 ? void 0 : (_state$draftOrder0$cu2 = _state$draftOrder0$cu.data) === null || _state$draftOrder0$cu2 === void 0 ? void 0 : _state$draftOrder0$cu2.appointment_time))), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-booking-success-location-row",
    className: "w-full p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between "
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--distance-outline-rounded",
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("p", {
    className: "text-xs font-bold text-black-primary leading-6"
  }, tShort("sell_trade_v2/success_inspection_location", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("p", {
    id: "sell-car-booking-success-location-value",
    className: "text-sm font-semibold text-black-primary"
  }, state === null || state === void 0 ? void 0 : (_state$draftOrder1 = state.draftOrder) === null || _state$draftOrder1 === void 0 ? void 0 : (_state$draftOrder1$cu = _state$draftOrder1.currentStep) === null || _state$draftOrder1$cu === void 0 ? void 0 : (_state$draftOrder1$cu2 = _state$draftOrder1$cu.data) === null || _state$draftOrder1$cu2 === void 0 ? void 0 : _state$draftOrder1$cu2.location))))), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-booking-success-caution",
    className: "p-3 border border-sold border-gray-echo rounded bg-[#FEFAEA] w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
    id: "sell-car-booking-success-caution-icon",
    src: CDN_LINK + "/assets/images/watrning-exc.svg",
    alt: "",
    width: 16,
    height: 12
  })), /*#__PURE__*/React.createElement("span", {
    id: "sell-car-booking-success-caution-label",
    className: "ps-0.5 font-bold text-xs text-black-primary"
  }, tShort("sell_trade_v2/caution", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("span", {
    id: "sell-car-booking-success-caution-text",
    className: "ps-0.5 font-normal text-xs text-black-primary"
  }, tShort("sell_trade_v2/caution_text", {
    ns: "web_sell_trade"
  })))), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-booking-success-home-btn",
    className: "w-full border border-solid border-primary-new rounded text-center text-primary-new text-base px-4 py-3 font-semibold cursor-pointer md:max-w-[330px] md:mx-auto",
    role: "button",
    onClick: handleGoHome
  }, tShort("sell_trade_v2/go_home", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement(If, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(AnyQuestion, {
    containerClassName: "!w-full"
  }))))))))));
};
export default CarBookingSuccessScreen;